export const CHECK_USER_SESSION = 'CHECK_USER_SESSION';

export const checkUserSession = () => ({
    type: CHECK_USER_SESSION,
});
